import React from 'react';
import { Spin } from 'antd';
import { CheckIcon, MinusIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useFeatures } from '../hooks';

const Features = () => {
  const { features, isLoading } = useFeatures();
  const { locale = 'uz' } = useRouter();
  const t = useTranslations();

  return (
    <div className="mx-auto max-w-[1042px] p-4 sm:p-0">
      <div className="my-20 relative overflow-hidden rounded-3xl bg-white p-4 sm:p-6">
        <div className="h-127 w-249 -left-70 -top-98 absolute z-0 bg-[url('/images/gradient_2.webp')] bg-cover bg-center" />
        <div className="h-127 w-270 -bottom-95 absolute left-0 z-0 bg-[url('/images/gradient_3.webp')] bg-cover bg-center" />

        <div className="overflow-x-auto">
          <Spin spinning={isLoading}>
            <table className="min-w-full text-left">
              <thead className="text-xs font-semibold text-gray-700 sm:text-lg">
                <tr>
                  <th className="w-54 pb-4 sm:w-3/4">{t('funksiyalar')}</th>
                  <th className="pb-4 pr-3 text-center">{t('bepul')}</th>
                  <th className="pb-4 text-center">Akam Pro</th>
                </tr>
              </thead>
              <tbody className="text-xs text-gray-800 sm:text-base">
                {features?.map((feature, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <tr key={index} className="border-t border-gray-100">
                    <td className="py-4">{feature?.name[locale as keyof typeof feature.name]}</td>
                    <td className="flex items-center justify-center py-4 pr-3">
                      {feature.is_free ? <CheckIcon /> : <MinusIcon />}
                    </td>
                    <td className="py-4">
                      <div className="flex items-center justify-center">
                        {feature.is_pro ? <CheckIcon /> : <MinusIcon />}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default Features;
